import axios from "axios";
import { config } from "../config";
import { apiVersion } from "./api";
import { authenticate, createResponseErrorHandler } from "./interceptors";

const queryParams = new URLSearchParams(location.search);
const feedbackUri = queryParams.get("feedbackUri");

export const feedbackApi = axios.create({
    baseURL: feedbackUri ? `${feedbackUri}/` : `${config.feedback.url}/`,
    headers: { "X-API-VERSION": apiVersion },
});

feedbackApi.interceptors.request.use(authenticate);
feedbackApi.interceptors.response.use((config) => config, createResponseErrorHandler(feedbackApi));
